import { definePermisos } from '../utils'

export const RESOURCE_INVENTARIO = 'Inventario' as const

const permission = definePermisos(RESOURCE_INVENTARIO, 'inventario', {
    mantenimiento: {
        bodega: 'bodega',
        categoriaBien: 'categorias-bien',
        gestionItems: 'gestion-item',
        inventarios: 'inventario',
        lineasBien: 'lineas-bien',
        marcas: 'marcas',
        crearCategoriaBien: 'crear-categoria',
        crearLineaBien: 'crear-linea',
        crearMarca: 'crear-marca',
        crearPolitica: 'crear-politica',
    },
    configuracion: {
        destinatarios: 'destinatarios',
        jefeBodega: 'jefe-bodega',
        nivelAprobacionOrdenPedido: 'nivel-aprobacion-orden-pedido',
        permisosBodega: 'permisos-bodega',
        politicaItem: 'politica-item',
        stockMinimo: 'stock-minimo',
    },
    transacciones: {
        ingresoBodega: 'ingreso-bodega',
        egresoBodega: 'egreso-bodega',
        confirmacionTransferencia: 'confirmacion-transferencia',
        gestionSolicitudesItems: 'gestion-solicitudes-item',
        aprobacionSolicitudItem: 'aprobacion-solicitud-item',
        aprobacionMarca: 'aprobacion-marca',
        crearSolicitudItem: 'crear-solicitud-item',
        aprobacionContableItems: 'aprobacion-contable-items',
        aprobacionTributariaItems: 'aprobacion-tributaria-items',
        crearSolicitudMarca: 'crear-solicitud-marca',
        gestionSolicitudDevolucion: 'gestion-solicitud-devolucion',
        solicitudDevolucion: 'solicitud-devolucion',
        aprobacionSolicitudDevolucion: 'aprobacion-solicitud-devolucion',
        gestionSolicitudConsumo: 'gestion-solicitud-consumo',
        solicitudConsumo: 'solicitud-consumo',
        aprobacionSolicitudConsumo: 'aprobacion-solicitud-consumo',
        gestionSolicitudTransferencia: 'gestion-solicitud-transferencia',
        solicitudTransferencia: 'solicitud-transferencia',
        aprobacionSolicitudTransferencia: 'aprobacion-solicitud-transferencia',
        gestionOrdenPedido: 'gestion-orden-pedido',
        crearOrdenPedido: 'crear-orden-pedido',
        aprobacionOrdenPedido: 'aprobacion-orden-pedido',
    },
    informes: {
        costoKardex: 'costo-kardex',
        estadoInventario: 'estado-inventario',
        estadoInventarioRotacion: 'estado-inventario-rotacion',
        informeReposicion: 'informe-reposicion',
        kardex: 'kardex',
        movimientoInventario: 'movimiento-inventario',
        movimientoInventarioGeneral: 'movimiento-inventario-general',
        movimientoTransferenciasAutomaticas: 'movimiento-transferencias-automaticas',
        rotacionAntiguedadInventario: 'rotacion-antiguedad-inventario',
        notaIngresoEgreso: 'nota-ingreso-egreso',
        resumenInventario: 'resumen-inventario',
        rotacionInventario: 'rotacion-inventario',
        stockMinimo: 'stock-minimo',
        tomaInventario: 'toma-inventario',
        politicasItem: 'politicas-item',
    },
    actions: {
        editarCostoItem: 'editar-costo-item',
    },
})

export default permission
